import React from 'react';
import { PoseGroup } from 'react-pose';
import './confirmation_window.scss';
import {FadeContainer, PopUpContainer, VerticalTwistContainer, VerticalContainer} from '../utils/pose_containers';
import DefaultMenuButton from './default_menu_button';

class ConfirmationWindow extends React.Component {
  getIcon() {
    if(this.props.loading) {
      return (
        <VerticalTwistContainer key="confirm_window_confirm_icon">
          <i className="fas fa-spinner confirmation-window__loading-icon"></i>
        </VerticalTwistContainer>
      );
    }
    else if(this.props.useSuccessIcon) {
      return (
        <VerticalTwistContainer key="confirm_window_success_icon">
          <i className="fas fa-circle-check confirmation-window__success-icon"></i>
        </VerticalTwistContainer>
      );
    }
    else if(this.props.useErrorIcon) {
      return (
        <VerticalTwistContainer key="confirm_window_error_icon">
          <i className="fas fa-times confirmation-window__error-icon"></i>
        </VerticalTwistContainer>
      );
    }

    return (
      <VerticalTwistContainer key="confirm_window_alert_icon">
        <i className="fas fa-exclamation-circle confirmation-window__alert-icon"></i>
      </VerticalTwistContainer>
    );
  }

  render() {
    return (
      <PoseGroup flipMove={false}>

        {this.props.visible &&
          <FadeContainer key="confirmation_window">

            <aside className={`confirmation-window${this.props.className ? ' ' + this.props.className : ''}`}>

              <PopUpContainer className="confirmation-window__container">

                <div className="confirmation-window__icon-wrapper">

                  <PoseGroup>

                    {this.getIcon()}

                  </PoseGroup>

                </div>

                <h2 className={`confirmation-window__title${this.props.loading ? '--pulsing' : ''}`}>

                  {this.props.title}

                </h2>

                <p className="confirmation-window__description">

                  {this.props.description}

                </p>

                <PoseGroup flipMove={false}>

                  {!this.props.loading &&
                    <VerticalContainer
                      key="confirmation_window__buttons"
                      className="confirmation-window__controls-wrapper"
                    >

                      {!this.props.hideCancelButton &&
                        <DefaultMenuButton
                          className="confirmation-window__cancel-button"
                          onClick={() => this.props.onCancel()}
                          text={this.props.cancelText || 'Cancelar'}
                        />
                      }

                      {!this.props.hideConfirmButton &&
                        <DefaultMenuButton
                          className="confirmation-window__confirm-button"
                          onClick={() => this.props.onConfirm()}
                          text={this.props.confirmText || 'Confirmar'}
                          color="red"
                        />
                      }

                    </VerticalContainer>
                  }

                </PoseGroup>

              </PopUpContainer>

            </aside>

          </FadeContainer>
        }

      </PoseGroup>
    );
  }
}

export default ConfirmationWindow;
